import { PartnerSetting } from "./defaults";
import SETTINGS_CTL_DATA from "./ctlWebchat.json";
import SETTINGS_CTL_UI_TEXT from "./ctlWebchatUIText";
const SETTINGS_CTL = {
  ...SETTINGS_CTL_DATA,
  text: SETTINGS_CTL_UI_TEXT,
} as PartnerSetting;
export default SETTINGS_CTL;
